export const creationRoute = '/production-flow/create';
export const strCurrentTabLink = 'production-flow-current-tab-link';
export const strDeliveryFormKeyLocalStoragePageSize = 'delivery-form-page-size';
export const strDeliveryFormKeyLocalStorageSort = 'delivery-form-sort-favorite';
export const strDeliveryFormState = 'delivery-form-state';
export const strFittingFormKeyLocalStoragePageSize = 'fitting-form-page-size';
export const strFittingFormKeyLocalStorageSort = 'fitting-form-sort-favorite';
export const strFittingFormState = 'fitting-form-state';
export const strInvoiceKeyLocalStoragePageSize = 'invoiced-delivery-form-page-size';
export const strInvoiceKeyLocalStorageSort = 'delivery-form-invoice-sort-favorite';
export const strInvoiceState = 'delivery-form-invoice-state';
export const strPeriodSearchTypeFavorite = 'production-flow-period-search-favorite';
export const strProFormaKeyLocalStoragePageSize = 'pro-forma-page-size';
export const strProFormaKeyLocalStorageSort = 'delivery-form-pro-forma-sort-favorite';
export const strProFormaState = 'delivery-form-pro-forma-state';
export const strQuoteKeyLocalStoragePageSize = 'quote-page-size';
export const strQuoteKeyLocalStorageSort = 'quote-sort-favorite';
export const strQuoteState = 'quote-state';
export const strWorkFormKeyLocalStoragePageSize = 'work-form-page-size';
export const strWorkFormKeyLocalStorageSort = 'work-form-sort-favorite';
export const strWorkFormPeriodSearchTypeFavorite = 'work-form-search-favorite';
export const strWorkFormState = 'work-form-state';
